import Firebase from '@firebase/app'
import { unregisterAllListeners } from 'registerListeners'
import {
  handleSigninErrorMessage,
  handleSignupErrorMessage,
  extractUserProperties,
  signInWorkflow,
  boardingWorkflow,
  signOutWorkflow
} from 'redux/helpers/authHelpers'
import { setUserData } from 'utils/ReportingUtils'
import { MODAL_NETWORK_OFF, showModal, hideModal, unmountModal } from './modals'
// ------------------------------------
// Constants
// ------------------------------------
export const SIGN_IN_REQUIRED = 'SIGN_IN_REQUIRED'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const UPDATE_FB_USER_SUCCESS = 'UPDATE_FB_USER_SUCCESS'
export const UPDATE_FB_USER_ERROR = 'UPDATE_FB_USER_ERROR'
export const UPDATE_DASH_USER_SUCCESS = 'UPDATE_DASH_USER_SUCCESS'
export const UPDATE_DASH_USER_ERROR = 'UPDATE_DASH_USER_ERROR'
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
export const SIGN_OUT_ERROR = 'SIGN_OUT_ERROR'
export const ONLINE_STATUS_ON = 'ONLINE_STATUS_ON'
export const ONLINE_STATUS_OFF = 'ONLINE_STATUS_OFF'
export const SIGN_UP_REQUESTED = 'SIGN_UP_REQUESTED'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SIGNUP_DONE = 'SIGNUP_DONE'
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const CONFIRMATION_EMAIL_SENT_SUCCESS = 'CONFIRMATION_EMAIL_SENT_SUCCESS'
export const CONFIRMATION_EMAIL_SENT_ERROR = 'CONFIRMATION_EMAIL_SENT_ERROR'
export const RESET_PASSWORD_SENT_SUCCESS = 'RESET_PASSWORD_SENT_SUCCESS'
export const RESET_PASSWORD_SENT_ERROR = 'RESET_PASSWORD_SENT_ERROR'
export const RESET_PASSWORD_CLEAR = 'RESET_PASSWORD_CLEAR'
// ------------------------------------
// Actions
// ------------------------------------
function updateFbUser() {
  return dispatch => {
    const fbUser = Firebase.auth().currentUser
    if (fbUser) {
      return dispatch({
        type: UPDATE_FB_USER_SUCCESS,
        payload: extractUserProperties(fbUser)
      })
    } else {
      return dispatch({ type: SIGN_IN_REQUIRED })
    }
  }
}

export function signInSuccess(user) {
  return dispatch => dispatch({ type: SIGN_IN_SUCCESS, user })
}
export function clearReset() {
  return dispatch => {
    dispatch({ type: RESET_PASSWORD_CLEAR })
  }
}
export function resetPassword(email) {
  return dispatch => {
    Firebase.auth()
      .sendPasswordResetEmail(email)
      .then(function() {
        dispatch({ type: RESET_PASSWORD_SENT_SUCCESS })
      })
      .catch(function(error) {
        if (error) {
          let errorMessage = handleSigninErrorMessage(error)
          dispatch({
            type: RESET_PASSWORD_SENT_ERROR,
            errorMessage: errorMessage
          })
        }
      })
  }
}
export function refreshToken() {
  return (dispatch, getState) => {
    const fbUser = Firebase.auth().currentUser
    if (fbUser) {
      return fbUser.getIdToken(true).then(idToken => {
        // document.cookie = `__session=${idToken};max-age=3600;`
        return dispatch({
          type: REFRESH_TOKEN,
          payload: `Bearer ${idToken}`
        })
      })
    } else {
      return dispatch({ type: SIGN_IN_REQUIRED })
    }
  }
}

export function signUp(email, pwd, firstName, lastName) {
  return (dispatch, getState) => {
    const payloadSignup = {
      displayName: `${firstName} ${lastName}`,
      firstName: firstName,
      lastName: lastName
    }
    dispatch({
      type: SIGN_UP_REQUESTED,
      payload: payloadSignup
    })
    Firebase.auth()
      .setPersistence(Firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        Firebase.auth()
          .createUserWithEmailAndPassword(email, pwd)
          .then(res => {
            dispatch(sendConfirmationEmail(true))
            dispatch({
              type: SIGN_UP_SUCCESS,
              payload: payloadSignup
            })
          })
          .catch(err => {
            if (err) {
              let errorMessage = handleSignupErrorMessage(err)
              dispatch({
                type: SIGN_UP_ERROR,
                errorMessage: errorMessage
              })
            }
          })
      })
  }
}
export function checkEmailVerification() {
  return (dispatch, getState) => {
    Firebase.auth().currentUser.reload()
    if (
      Firebase.auth().currentUser.emailVerified !==
      getState().auth.emailVerified
    ) {
      dispatch({
        type: UPDATE_FB_USER_SUCCESS,
        payload: extractUserProperties(Firebase.auth().currentUser)
      })
    }
  }
}
export function sendConfirmationEmail(isFirst) {
  return (dispatch, getState) => {
    const user = Firebase.auth().currentUser
    user
      .sendEmailVerification()
      .then(function() {
        if (isFirst) return
        dispatch({ type: CONFIRMATION_EMAIL_SENT_SUCCESS })
      })
      .catch(function(error) {
        if (error) {
        }
        // An error happened.
      })
  }
}
export function authenticate(email, pwd) {
  return (dispatch, getState) => {
    Firebase.auth()
      .setPersistence(Firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        return Firebase.auth().signInWithEmailAndPassword(email, pwd)
      })
      .then((fbUser, error) => {
        const user = extractUserProperties(fbUser)
        dispatch({
          type: SIGN_IN_SUCCESS,
          payload: user
        })
      })
      .catch(function(error) {
        // Handle Errors here.
        if (error) {
          let errorMessage = handleSigninErrorMessage(error)
          dispatch({
            type: SIGN_IN_ERROR,
            errorMessage: errorMessage
          })
        }
      })
  }
}
function registerUserListeners(uid) {
  return (dispatch, getState) => {
    Firebase.database()
      .ref(`users/${uid}`)
      .on('value', snap => {
        dispatch({
          type: UPDATE_DASH_USER_SUCCESS,
          payload: snap.val()
        })
        const { signupData } = getState().auth
        if (signupData && snap.val() !== null) {
          Firebase.database()
            .ref(`users/${uid}`)
            .update(signupData)
          Firebase.auth().currentUser.updateProfile({
            displayName: signupData.displayName
          })
          dispatch({ type: SIGNUP_DONE })
        }
      })
  }
}

export function registerOnlineListeners(store) {
  return (dispatch, getState) => {
    Firebase.database()
      .ref('.info/connected')
      .on('value', snap => {
        if (snap.val() === true) {
          dispatch({
            type: ONLINE_STATUS_ON
          })
          if (getState().modals.currentModal === MODAL_NETWORK_OFF) {
            dispatch(hideModal(MODAL_NETWORK_OFF))
            dispatch(unmountModal())
          }
          // dispatch(sync())
        } else {
          dispatch({
            type: ONLINE_STATUS_OFF
          })
          dispatch(showModal(MODAL_NETWORK_OFF))
        }
      })
  }
}
function getDashUser(uid) {
  return dispatch => {
    return Firebase.database()
      .ref(`users/${uid}`)
      .once('value')
      .then(snap => {
        if (snap.val() === null) {
          return Promise.resolve()
        }
        return dispatch({
          type: UPDATE_DASH_USER_SUCCESS,
          payload: snap.val()
        })
      })
  }
}
export function registerAuthListeners(store) {
  return (dispatch, getState) => {
    Firebase.auth().onAuthStateChanged(user => {
      if (user) {
        let fbUser = extractUserProperties(user)
        if (fbUser.uid) {
          registerUserListeners(fbUser.uid)(dispatch, getState)
          return Promise.all([
            dispatch(updateFbUser()),
            dispatch(getDashUser(fbUser.uid)),
            dispatch(refreshToken())
          ])
            .then(result => {
              return dispatch(signInSuccess(result[0].payload))
            })
            .then(user => {
              const { auth } = getState()
              setUserData(auth)
              if (
                !auth.emailVerified ||
                (auth.boarding && !auth.boarding.finished)
              ) {
                dispatch(boardingWorkflow(auth))
              } else {
                dispatch(signInWorkflow(auth))
              }
            })
            .catch(err => {
              console.error(err)
              return dispatch({ type: SIGN_IN_REQUIRED })
            })
        }
      } else {
        return dispatch(signOutWorkflow())
      }
    }, handleAuthError(dispatch))
  }
}
export const handleAuthError = dispatch => error => {
  if (error) {
    console.warn('Firebase Error : ', error)
    dispatch(signOutWorkflow())
  }
}
export function signOut() {
  return (dispatch, getState) => {
    return dispatch(unregisterAllListeners()).then(() => {
      Firebase.auth()
        .signOut()
        .then(() => {
          dispatch({
            type: SIGN_OUT_SUCCESS
          })
          dispatch({ type: 'RESET' })
          window.location.reload(false)
        })
    })
  }
}

export const actions = {
  authenticate,
  registerAuthListeners,
  signOut
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SIGN_IN_REQUIRED]: (state, action) => ({ authenticated: false }),
  [ONLINE_STATUS_ON]: (state, action) => ({ ...state, isOnline: true }),
  [ONLINE_STATUS_OFF]: (state, action) => ({ ...state, isOnline: false }),
  [SIGN_IN_SUCCESS]: (state, action) => ({
    ...state,
    ...action.payload,
    authenticated: true
  }),
  [REFRESH_TOKEN]: (state, action) => ({ ...state, bearer: action.payload }),
  [SIGN_UP_REQUESTED]: (state, action) => ({
    ...state,
    signupData: action.payload
  }),
  [SIGN_UP_SUCCESS]: (state, action) => ({
    ...state,
    signupData: action.payload
  }),
  [SIGN_UP_ERROR]: (state, action) => ({ errorMessage: action.errorMessage }),
  [SIGNUP_DONE]: (state, action) => ({ ...state, signupData: void 0 }),
  [SIGN_IN_ERROR]: (state, action) => ({ errorMessage: action.errorMessage }),
  [SIGN_OUT_SUCCESS]: (state, action) => ({ authenticated: false }),
  [SIGN_OUT_ERROR]: (state, action) => state,
  [CONFIRMATION_EMAIL_SENT_SUCCESS]: (state, action) => ({
    ...state,
    emailSent: true
  }),
  [CONFIRMATION_EMAIL_SENT_ERROR]: (state, action) => ({
    ...state,
    emailSent: false
  }),
  [UPDATE_FB_USER_SUCCESS]: (state, action) => ({
    ...state,
    ...action.payload
  }),
  [UPDATE_DASH_USER_SUCCESS]: (state, action) => ({
    ...state,
    ...action.payload
  }),
  [UPDATE_DASH_USER_ERROR]: (state, action) => ({
    errorMessage: action.errorMessage
  }),
  [RESET_PASSWORD_SENT_SUCCESS]: (state, action) => ({
    resetSuccess: 'Email Envoyé'
  }),
  [RESET_PASSWORD_SENT_ERROR]: (state, action) => ({
    errorMessage: action.errorMessage
  }),
  [RESET_PASSWORD_CLEAR]: (state, action) => ({
    resetSuccess: void 0,
    errorMessage: void 0
  })
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  authenticated: null
}

export default function authReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/auth.js